import { createContext, useContext } from 'react'
import type { Map as MapLibreMap } from 'maplibre-gl'

/** Non-null only under a MapView whose style has finished loading. */
export const MapContext = createContext<MapLibreMap | null>(null)

export function useMap(): MapLibreMap | null {
  return useContext(MapContext)
}
